import LocalStorageCache from 'lyjs/es/cache/LocalStorageCache'

export default new LocalStorageCache('shops')



// WEBPACK FOOTER //
// ./src/services/cache/shops.js